import { lazy } from 'react';
import { useAppSelector, shallowEqual } from 'store/hook';
// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard')));
const CreateCard = Loadable(lazy(() => import('views/cards/create')));
const CardList = Loadable(lazy(() => import('views/cards/list')));
const CardTransition = Loadable(lazy(() => import('views/cards/transition')));
const AccountTransition = Loadable(lazy(() => import('views/finance/transaction')));
const Setting = Loadable(lazy(() => import('views/setting')));
const Topup = Loadable(lazy(() => import('views/topup')));
const Help = Loadable(lazy(() => import('views/help')));
const Agent = Loadable(lazy(() => import('views/agent')));
const Risk = Loadable(lazy(() => import('views/risk')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = () => {
  const agent = useAppSelector(({ user }) => user.user?.account?.agent, shallowEqual);
  const isSubUser = useAppSelector(({ user }) => user.user?.account?.isGroupSubUser, shallowEqual);
  const enable = useAppSelector(({ user }) => user.user?.overview?.groupConfig?.enable, shallowEqual);
  return {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <DashboardDefault />
      },
      {
        path: 'dashboard',
        element: <DashboardDefault />
      },
      {
        path: '/cards/create',
        element: <CreateCard />
      },
      {
        path: '/cards/list',
        element: <CardList />
      },
      {
        path: '/cards/transaction',
        element: <CardTransition />
      },
      {
        path: '/account/transaction',
        element: <AccountTransition />
      },
      {
        path: '/account/setting',
        element: <Setting />
      },
      {
        path: '/account/topup',
        element: <Topup />
      },
      {
        path: '/account/help',
        element: <Help />
      },
      {
        path: '/account/risk',
        element: <Risk />
      },
      {
        path: '/agent',
        element: <Agent />
      }
    ]
  };
};

export default MainRoutes;
